import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { CalendarIcon } from '@radix-ui/react-icons';
import { format } from 'date-fns';
import { useState } from 'react';
import { Button } from '../ui/button';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

interface IProps {
  name: string;
  label?: string | null;
  placeholder?: string;
  className?: string;
  control: any;
  description?: string;
  required?: boolean;
  withoutDescription?: boolean;
  labelClass?: string;
  inputClass?: string;
}

export default function DatepickerControl({
  name,
  label,
  placeholder,
  control,
  description,
  className,
  required,
  withoutDescription,
  inputClass,
  labelClass,
}: IProps) {
  const [open, setOpen] = useState(false);

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(className)}>
          {label && (
            <FormLabel className={labelClass}>
              {label} {required && <span className={cn('text-red')}>*</span>}
            </FormLabel>
          )}
          <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
              <FormControl>
                <Button
                  variant={'ghost'}
                  onClick={() => setOpen(!open)}
                  className={cn(
                    !field.value && 'text-muted-foreground',
                    inputClass,
                    'flex w-full text-black items-center justify-between whitespace-nowrap rounded-lg border border-gray-300 bg-transparent hover:bg-transparent px-3 py-2 text-sm  ',
                  )}
                >
                  {field.value ? field.value : <span>{placeholder}</span>}
                  <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={field.value ? new Date(field.value) : undefined}
                onSelect={(date) => {
                  field.onChange(date ? format(date, 'yyyy-MM-dd') : null);
                  setOpen(false);
                }}
                disabled={(date) =>
                  date > new Date() || date < new Date('2000-01-01')
                }
              />
            </PopoverContent>
          </Popover>
          {!withoutDescription && (
            <div className="absolute -bottom-[18px] right-0">
              {description && <FormDescription>{description}</FormDescription>}
              <div className={'h-4 !mt-1'}>
                <FormMessage />
              </div>
            </div>
          )}
        </FormItem>
      )}
    />
  );
}
